export const LOGIN = 'LOGIN'

export interface LoginState {
   // loginToken: string | undefined
}

export interface LoginAction {
    type: typeof LOGIN,
    payload: string
}

export type LoginActionTypes = LoginAction